export const classes = {
  wrapper:
    'place-center h-screen w-screen overflow-hidden bg-default-gradient bg-cover bg-no-repeat dark:bg-none dark:bg-[#1a1620]',
  card: 'flex items-center rounded-2xl border border-white/70 bg-white/80 px-16 py-12 text-base font-medium text-taupe-3 shadow-glass backdrop-blur-lg dark:border-white/[0.12] dark:bg-[#332e43]/80 dark:text-mauve-1 dark:shadow-glass-dark',
};
